module.exports = __webpack_public_path__ + "fonts/Inter-300-vietnamese22.74fe938.woff2";